import React, { useEffect, useState } from "react";
import About from "../components/aboutus/About";
import Manager from "../components/home/Manager";
// import Experience from '../components/aboutus/Experience';
import HotelDetails from "../components/aboutus/HotelDetails";
import { useLoader } from "../context/LoaderContext";
import { dynamicFailed } from "../hooks/useToast";
import { fetchAboutUsBanner, fetchAboutUsDetails } from "../api/AboutUsApi";
import { IAboutUsBannerData, IAboutUsData } from "../exports/interfaces";
import { fetchManagerMessage } from "../api/HomeApi";
import { useManagerContext } from "../context/HomeContext";
// import MissionVision from '../components/aboutus/MissionVision';

const AboutUs = () => {
  const { setLoading } = useLoader();
  const [aboutUs, setAboutUs] = useState<IAboutUsBannerData[]>([]);
  const [aboutUsData, setAboutUsData] = useState<IAboutUsData[]>([]);
  const { managerData, setManagerData } = useManagerContext();
  useEffect(() => {
    Promise.all([fetchAboutUsBanner(), fetchAboutUsDetails()])
      .then(([AboutUsBannerData, AboutUsData]) => {
        setAboutUs(AboutUsBannerData);
        setAboutUsData(AboutUsData);
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
        dynamicFailed(error.response.data.error.message);
      });
  }, [setLoading]);
  useEffect(() => {
    if (managerData.length === 0) {
      Promise.all([fetchManagerMessage()])
        .then(([ManagerData]) => {
          setManagerData(ManagerData);
        })
        .catch((error) => {
          dynamicFailed(error.response.data.error.message);
        });
    }
  }, [managerData.length, setManagerData]);
  return (
    <>
      <body
        data-rsssl="1"
        className="home page-template-default page page-id-662 tg_menu_transparent tg_lightbox_black centeralign2 loftloader-lite-enabled elementor-default elementor-kit-2567 elementor-page elementor-page-662"
        // onLoad={() => setTimeout(() => setLoading(false), 2000)}
      >
        {/* <!-- Begin content --> */}
        <div
          id="page_content_wrapper"
          className="noheader"
          style={{ padding: "unset" }}
        >
          <div className="inner">
            {/* <!-- Begin main content --> */}
            <div className="inner_wrapper">
              <div className="sidebar_content full_width">
                <div
                  data-elementor-type="wp-post"
                  data-elementor-id="278"
                  className="elementor elementor-278 elementor-662"
                  data-elementor-settings="[]"
                >
                  <div className="elementor-inner">
                    <div className="elementor-section-wrap">
                      <About aboutUs={aboutUs} />
                      <Manager />
                      {/* <Experience /> */}
                      <HotelDetails aboutUsData={aboutUsData} />
                      {/* <MissionVision/> */}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* <!-- End main content --> */}
          </div>
          <br className="clear" />
        </div>
      </body>
    </>
  );
};

export default AboutUs;
